import React from "react";

const Main = ({ className, children }) => (
  <div className={"main pi-wrapper " + className}>{children}</div>
);

export default Main;
